module.exports = __webpack_public_path__ + "img/isotipo2.81fbc6ca.svg";